import React, { memo } from "react";

export const View = memo(({ children, className, ...props }) => {
  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
});
